import Host from "@interfaces/device/host"
import Tooltip from '@material-ui/core/Tooltip';

type HostItemActionsProps = {
    host: Host
    setHostToEdit: () => void
    deleteHosTModal: () => void
}

const HostItemActions = (props: HostItemActionsProps) => {

    return (
        <div className="Devices__HostItem">
            <div className="HorizontalFlex__Gap">
                <i className='fas fa-folder'/>
                <p className="Body2-600">{props.host.identificationHost}</p>
            </div>
            <div className="HorizontalFlex__Gap">
                <Tooltip title="Editar">
                    <button className="ButtonTertiary">
                        <i className="fas fa-pen" onClick={() => props.setHostToEdit()} />
                    </button>
                </Tooltip>
                <Tooltip title="Eliminar">
                    <button className="ButtonTertiary">
                        <i className="fas fa-trash-alt" onClick={() => props.deleteHosTModal()} />
                    </button>
                </Tooltip>
            </div>
        </div>
    )
}
export default HostItemActions
